import { render } from "./DeviatedComponentReport.vue?vue&type=template&id=0eb20b88&scoped=true"
import script from "./DeviatedComponentReport.vue?vue&type=script&lang=js"
export * from "./DeviatedComponentReport.vue?vue&type=script&lang=js"

import "./DeviatedComponentReport.vue?vue&type=style&index=0&id=0eb20b88&scoped=true&lang=css"

import exportComponent from "/private/var/www/html/digicheck-laravel-vue-app/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eb20b88"]])

export default __exports__